import React, { useContext } from 'react';
import './footer.styles.scss';
import { GlobalDispatchContext } from '../../context/globalContextProvider';


import soundcloud from '../../assets/logos/soundcloud.png'
import soundbetter from '../../assets/logos/soundbetter.png';


const Footer = () => {

    const dispatch = useContext(GlobalDispatchContext);

    const openPolicy = () => {
        window.scrollTo(0, 0)
        dispatch({
            type: 'SET_POLICY_OPEN',
            policyIsOpen: true
        })
    }
   
    return (
        <div className="footer-container">
            <div className="footer-top">
                <h3>
                    LET'S STAY IN TOUCH
                </h3>
            </div>
            <div className="footer-lower">
                <div className="site-created policy">
                    <p onClick={openPolicy}>privacy policy</p>
                    
                </div>
                <div className="sample-links">
                    {/* <a href='https://www.instagram.com/ingridgaral/' rel="noopener noreferrer" target="_blank"><img src={instagramSketched} alt="instagramSketched"/></a> */}
                    <a href='https://soundcloud.com/user-884790587-99361613/sets' rel="noopener noreferrer" target="_blank"><img className="soundcloud" src={soundcloud} alt="soundcloud"/></a>
                    {/* <a href='https://www.youtube.com/channel/UChUrqs4iCM59tFcFDP4FFZw?view_as=subscriber' rel="noopener noreferrer" target="_blank"><img src={youtube} alt="youtube"/></a> */}
                    <a href='https://soundbetter.com/profiles/287828-ingrid-garal' rel="noopener noreferrer" target="_blank"><img src={soundbetter} alt="soundbetter" /> </a> 


                </div>
                <div className="site-created">
                    <p>@2020 INGRID ALCALDE</p>
                    <p>Created by Lloyd Rhodes</p>
                </div>
            </div>

        </div>
    )
}

export default Footer;